/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPYESORNO = {
    Yes: '1',
    No: '2'
} as const;
export type IAPYESORNO = typeof IAPYESORNO[keyof typeof IAPYESORNO];


export function IAPYESORNOFromJSON(json: any): IAPYESORNO {
    return IAPYESORNOFromJSONTyped(json, false);
}

export function IAPYESORNOFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPYESORNO {
    return json as IAPYESORNO;
}

export function IAPYESORNOToJSON(value?: IAPYESORNO | null): any {
    return value as any;
}

